import clsx from 'clsx';
const cn = clsx;
export default cn;
//# sourceMappingURL=cn.js.map